import { useState, useEffect, useMemo } from 'react';
import {
  getCountryMapCache,
  setCountryMapCache,
} from '@intelligence/pages/MarketProfile/_config/cache';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';

export function useCachedCountryMap() {
  const queryCountryMap = useQueryDefinition('countryMap') || [];

  // 避免频繁获取
  const initialCache = useMemo(() => getCountryMapCache(), []);

  const [countryMap, setCountryMap] = useState<any[]>(() => {
    // const cached = getCountryMapCache();
    // return cached && cached.length > 0 ? cached : queryCountryMap;

    return initialCache && initialCache.length > 0 ? initialCache : queryCountryMap;
  });

  useEffect(() => {
    if (queryCountryMap.length > 0) {
      setCountryMap(queryCountryMap);
      setCountryMapCache(queryCountryMap);
    } else if (!countryMap.length) {
      // 只在为空时，进行获取
      const cachedData = getCountryMapCache();
      if (cachedData && cachedData.length > 0) {
        setCountryMap(cachedData);
      }
    }
  }, [queryCountryMap]);

  return {
    countryMap: countryMap || [],
    isLoading: countryMap === null,
  };
}
